"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SITES_API_NO_RESULTS_RESPONSE = exports.GET_SITES_SERVICES_API_RESPONSE_400 = exports.GET_SITES_API_RESPONSE_400 = exports.GET_SITES_API_RESPONSE_404 = exports.GET_NOVASOL_API_RESPONSE_200_DATED_SEARCH = exports.GET_NOVASOL_API_RESPONSE_200 = exports.GET_SITES_SERVICES_API_RESPONSE_200 = exports.GET_SITES_API_RESPONSE_200 = void 0;
exports.GET_SITES_API_RESPONSE_200 = {
    total: 10000,
    rhsLevel: 'rhs1',
    sites: [
        {
            code: 'HART',
            displayName: 'Hart&rsquo;s',
            grade: '3',
            offers: [
                '<em>Up to an EXTRA &pound;70* off summer breaks</em>Limited time only &ndash; terms & conditions apply https://www.hoseasons.co.uk/terms-and-conditions',
            ],
            location: 'Leysdown, Isle of Sheppey',
            fromPrice: 230.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'Kent',
            services: [],
        },
        {
            code: 'LCPK',
            displayName: 'Looe Country Park',
            grade: '3',
            offers: [],
            location: 'Looe',
            fromPrice: 761.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'LLHP',
            displayName: 'Lowgate Lakes',
            grade: '3',
            offers: [],
            location: 'Fleet',
            fromPrice: 589.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'LMFL',
            displayName: 'Little Moorland Farm Lodges',
            grade: '3',
            offers: [
                '<em>Up to an EXTRA &pound;70* off summer breaks</em>Limited time only &ndash; terms & conditions apply https://www.hoseasons.co.uk/terms-and-conditions',
            ],
            location: 'Chapel Allerton',
            fromPrice: 499.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'APPU',
            displayName: 'Appuldurcombe Gardens Holiday Park',
            grade: '3',
            offers: [],
            location: 'Wroxall, Nr Ventnor',
            fromPrice: 517.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'BEYO',
            displayName: 'Landal Barton Pines',
            grade: '3',
            offers: [
                '<em>Summer breaks from &pound;349</em>Price Point is based off breaks arriving between the 6th June 2022 and 21st July 2022. New bookings only. Offer may vary between accommodation type and date/duration searched. Subject to availability. We reserve the right to withdraw this offer at any time.',
            ],
            location: 'Paignton, South Devon',
            fromPrice: 299.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'BLAK',
            displayName: 'Blackwood Forest Lodges',
            grade: '3',
            offers: [],
            location: 'Micheldever, Nr Winchester',
            fromPrice: 835.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'BMIL',
            displayName: 'Bath Mill Lodge Retreat',
            grade: '3',
            offers: [
                '<em>Summer Savings and Pets Go Free!*</em>Find great savings on your summer break, plus bring your dog for free in all our pet friendly accommodation, for the entire summer! Find full terms and conditions at https://www.hoseasons.co.uk/terms-and-conditions',
            ],
            location: 'Newton Saint Loe, Nr Bath',
            fromPrice: 329.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'BRMC',
            displayName: 'Brigg Marina',
            grade: '3',
            offers: [
                '<em>Big savings up to &pound;300 on your September break!</em>Savings up to &pound;300 between 2nd September - 30th September 2022. Offer may vary depending on accommodation type, and date/duration selected. Offer can be withdrawn any time. New bookings only. Subject to availability.',
            ],
            location: 'Brigg',
            fromPrice: 359.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'BURC',
            displayName: 'Burcott Country Retreats',
            grade: '3',
            offers: [
                '<em>Black Friday Savings!</em>We currently feature a selection of lodge, park, and cottage locations offering discounted reductions on selected accommodation of up to 10% off new bookings, when booked on an accommodation only basis. This discount is based on 3, 4, or 7 night stays, for selected dates, arriving between 26/11/21 and 07/04/22. At some locations minimum spend applies. Can be combined with other offers. Bookings must be made between 25/11/21 &ndash; 29/11/21. This discount is subject to availability and we reserve the right to withdraw or extend this offer at any time, without notice, at our sole discretion. Booking terms and conditions apply, please see website. Discount included within price shown at time of booking.',
            ],
            location: 'Wookey, Wells',
            fromPrice: 649.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'CLUN',
            displayName: 'Clun Valley Lodges',
            grade: '3',
            offers: [
                '<em>Black Friday Savings!</em>We currently feature a selection of lodge, park, and cottage locations offering discounted reductions on selected accommodation of up to 10% off new bookings, when booked on an accommodation only basis. This discount is based on 3, 4, or 7 night stays, for selected dates, arriving between 26/11/21 and 07/04/22. At some locations minimum spend applies. Can be combined with other offers. Bookings must be made between 25/11/21 &ndash; 29/11/21. This discount is subject to availability and we reserve the right to withdraw or extend this offer at any time, without notice, at our sole discretion. Booking terms and conditions apply, please see website. Discount included within price shown at time of booking.',
            ],
            location: 'Clunton, Craven Arms',
            fromPrice: 429.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
        {
            code: 'CRAK',
            displayName: 'Crake Valley',
            grade: '3',
            offers: [
                '<em>Up to an EXTRA &pound;70* off summer breaks</em>Limited time only &ndash; terms & conditions apply https://www.hoseasons.co.uk/terms-and-conditions',
            ],
            location: 'Water Yeat, Nr Coniston',
            fromPrice: 499.0,
            price: null,
            wasPrice: null,
            novasolProperty: null,
            rhs3: 'rhs3',
            services: [],
        },
    ],
    aggregations: {
        features: [
            {
                featureId: '6410',
                featureName: 'Golf nearby',
                featureCode: null,
                count: 6425,
            },
            {
                featureId: '9128',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 983,
            },
            {
                featureId: '3070',
                featureName: 'Beach Nearby',
                featureCode: null,
                count: 4939,
            },
            {
                featureId: '10135',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 40,
            },
            {
                featureId: '13401',
                featureName: 'Autumn Savers',
                featureCode: null,
                count: 1569,
            },
            {
                featureId: '10278',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 52,
            },
            {
                featureId: '6284',
                featureName: 'Ground Floor Facilities',
                featureCode: null,
                count: 3763,
            },
            {
                featureId: '10839',
                featureName: 'Electric Vehicle Charging Point',
                featureCode: null,
                count: 525,
            },
            {
                featureId: '6788',
                featureName: 'Decorated at Christmas',
                featureCode: null,
                count: 4701,
            },
            {
                featureId: '4169',
                featureName: 'Woodburner',
                featureCode: null,
                count: 42,
            },
            {
                featureId: '10295',
                featureName: 'All Ensuite',
                featureCode: null,
                count: 1743,
            },
            {
                featureId: '11304',
                featureName: 'Train Station Within 1 Mile',
                featureCode: null,
                count: 1323,
            },
            {
                featureId: '10275',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 70,
            },
            {
                featureId: '9133',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 406,
            },
            {
                featureId: '10132',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 40,
            },
            {
                featureId: '6734',
                featureName: 'Wheelchair Accessible',
                featureCode: null,
                count: 395,
            },
            {
                featureId: '11198',
                featureName: 'Summer Sell Out',
                featureCode: null,
                count: 4155,
            },
            {
                featureId: '9244',
                featureName: 'Pets Allowed',
                featureCode: 'SUPER',
                count: 8419,
            },
            {
                featureId: '2562',
                featureName: 'Open Fire or Woodburner',
                featureCode: null,
                count: 5185,
            },
            {
                featureId: '6275',
                featureName: 'Dishwasher',
                featureCode: null,
                count: 10424,
            },
            {
                featureId: '9130',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 72,
            },
            {
                featureId: '6473',
                featureName: 'Grouped Property',
                featureCode: null,
                count: 3812,
            },
            {
                featureId: '3223',
                featureName: 'Romantic Breaks',
                featureCode: null,
                count: 2,
            },
            {
                featureId: '6482',
                featureName: 'Sea View',
                featureCode: 'SUPER',
                count: 1413,
            },
            {
                featureId: '10089',
                featureName: 'Coastal Within 1 Mile',
                featureCode: null,
                count: 4097,
            },
            {
                featureId: '10129',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 322,
            },
            {
                featureId: '10977',
                featureName: 'Unique Cottages',
                featureCode: 'Super',
                count: 695,
            },
            {
                featureId: '9136',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 205,
            },
            {
                featureId: '10136',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 200,
            },
            {
                featureId: '6554',
                featureName: 'Pets Free of Charge',
                featureCode: null,
                count: 5039,
            },
            {
                featureId: '10279',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 22,
            },
            {
                featureId: '10096',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 16,
            },
            {
                featureId: '6401',
                featureName: 'Garden or Patio',
                featureCode: null,
                count: 11731,
            },
            {
                featureId: '9153',
                featureName: 'Luxury',
                featureCode: 'SUPER',
                count: 3184,
            },
            {
                featureId: '9125',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 280,
            },
            {
                featureId: '3032',
                featureName: 'Indoor Heated Pool',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9318',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 50,
            },
            {
                featureId: '3052',
                featureName: 'Kids Clubs',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9737',
                featureName: 'Pets Allowed',
                featureCode: 'SUPER',
                count: 6235,
            },
            {
                featureId: '10090',
                featureName: 'Coastal Within 3 Miles',
                featureCode: null,
                count: 5268,
            },
            {
                featureId: '6590',
                featureName: 'Rural',
                featureCode: 'SUPER',
                count: 5031,
            },
            {
                featureId: '9155',
                featureName: 'Daisy Door',
                featureCode: 'SPECCOLL',
                count: 1,
            },
            {
                featureId: '10130',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 66,
            },
            {
                featureId: '2942',
                featureName: 'Promote On Availability',
                featureCode: null,
                count: 14,
            },
            {
                featureId: '10128',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 81,
            },
            {
                featureId: '6581',
                featureName: 'Romantic Getaways',
                featureCode: 'SUPER',
                count: 2145,
            },
            {
                featureId: '3732',
                featureName: 'WiFi',
                featureCode: null,
                count: 30,
            },
            {
                featureId: '10408',
                featureName: 'Parking - On Site',
                featureCode: null,
                count: 12286,
            },
            {
                featureId: '10276',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 20,
            },
            {
                featureId: '9132',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 134,
            },
            {
                featureId: '3895',
                featureName: 'Promote On Availability',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '10133',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 205,
            },
            {
                featureId: '9278',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 36,
            },
            {
                featureId: '10091',
                featureName: 'Coastal Within 5 Miles',
                featureCode: null,
                count: 6191,
            },
            {
                featureId: '6194',
                featureName: 'Cycle Store',
                featureCode: null,
                count: 3324,
            },
            {
                featureId: '9126',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 92,
            },
            {
                featureId: '6464',
                featureName: 'Hot Tub',
                featureCode: 'SUPER',
                count: 1526,
            },
            {
                featureId: '9138',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 650,
            },
            {
                featureId: '3056',
                featureName: 'Kids Play Area',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6419',
                featureName: 'Games Room',
                featureCode: null,
                count: 703,
            },
            {
                featureId: '6428',
                featureName: 'Highchair Available',
                featureCode: null,
                count: 7274,
            },
            {
                featureId: '9361',
                featureName: 'Newly Listed Property',
                featureCode: null,
                count: 2487,
            },
            {
                featureId: '3050',
                featureName: 'Family Entertainment',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6392',
                featureName: 'Enclosed garden or patio',
                featureCode: null,
                count: 5683,
            },
            {
                featureId: '7070',
                featureName: 'Baby and Toddler Friendly',
                featureCode: 'SUPER',
                count: 896,
            },
            {
                featureId: '10902',
                featureName: "Water's Edge",
                featureCode: null,
                count: 5,
            },
            {
                featureId: '10277',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 38,
            },
            {
                featureId: '11184',
                featureName: 'Home From Home',
                featureCode: null,
                count: 5215,
            },
            {
                featureId: '9277',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 50,
            },
            {
                featureId: '8821',
                featureName: 'Cot Available',
                featureCode: null,
                count: 7728,
            },
            {
                featureId: '9131',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 325,
            },
            {
                featureId: '11789',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 19,
            },
            {
                featureId: '10134',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 98,
            },
            {
                featureId: '9161',
                featureName: 'Swimming Pool',
                featureCode: 'SUPER',
                count: 729,
            },
            {
                featureId: '6455',
                featureName: 'Pub Within 1 Mile',
                featureCode: null,
                count: 8483,
            },
            {
                featureId: '9127',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 101,
            },
            {
                featureId: '3074',
                featureName: 'Fishing Nearby',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6948',
                featureName: 'Wi-Fi',
                featureCode: 'SUPER',
                count: 14079,
            },
            {
                featureId: '9198',
                featureName: 'Fishing Nearby',
                featureCode: 'SUPER',
                count: 4546,
            },
            {
                featureId: '10137',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 83,
            },
            {
                featureId: '6185',
                featureName: 'Barbecue',
                featureCode: null,
                count: 4732,
            },
            {
                featureId: '9782',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 169,
            },
            {
                featureId: '3080',
                featureName: 'Access - Wheelchair',
                featureCode: null,
                count: 103,
            },
            {
                featureId: '10638',
                featureName: "Customers' Choice",
                featureCode: null,
                count: 2972,
            },
            {
                featureId: '10424',
                featureName: 'Childrens Play Area',
                featureCode: null,
                count: 539,
            },
            {
                featureId: '13083',
                featureName: 'Glamping Collection',
                featureCode: null,
                count: 246,
            },
            {
                featureId: '10274',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 54,
            },
            {
                featureId: '11182',
                featureName: 'Pet - More Than Dog Friendly',
                featureCode: null,
                count: 488,
            },
            {
                featureId: '10131',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 260,
            },
            {
                featureId: '10966',
                featureName: 'Waterside Breaks',
                featureCode: null,
                count: 1868,
            },
            {
                featureId: '3084',
                featureName: 'Hot Tub - Private',
                featureCode: null,
                count: 329,
            },
            {
                featureId: '9137',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 436,
            },
            {
                featureId: '9857',
                featureName: 'Pet(s) Allowed',
                featureCode: null,
                count: 11983,
            },
        ],
        siteFeatures: [
            {
                featureId: '6948',
                featureName: 'Wi-Fi',
                featureCode: 'SUPER',
                count: 15543,
            },
            {
                featureId: '10408',
                featureName: 'Parking - On Site',
                featureCode: null,
                count: 13726,
            },
            {
                featureId: '6401',
                featureName: 'Garden or Patio',
                featureCode: null,
                count: 12740,
            },
            {
                featureId: '6275',
                featureName: 'Dishwasher',
                featureCode: null,
                count: 11088,
            },
            {
                featureId: '6455',
                featureName: 'Pub Within 1 Mile',
                featureCode: null,
                count: 9216,
            },
            {
                featureId: '9244',
                featureName: 'Pets Allowed',
                featureCode: 'SUPER',
                count: 9183,
            },
            {
                featureId: '8821',
                featureName: 'Cot Available',
                featureCode: null,
                count: 8174,
            },
            {
                featureId: '6428',
                featureName: 'Highchair Available',
                featureCode: null,
                count: 7680,
            },
            {
                featureId: '6410',
                featureName: 'Golf nearby',
                featureCode: null,
                count: 7066,
            },
            {
                featureId: '10091',
                featureName: 'Coastal Within 5 Miles',
                featureCode: null,
                count: 6830,
            },
            {
                featureId: '9737',
                featureName: 'Pets Allowed',
                featureCode: 'SUPER',
                count: 6804,
            },
            {
                featureId: '6392',
                featureName: 'Enclosed garden or patio',
                featureCode: null,
                count: 5954,
            },
            {
                featureId: '10090',
                featureName: 'Coastal Within 3 Miles',
                featureCode: null,
                count: 5769,
            },
            {
                featureId: '11184',
                featureName: 'Home From Home',
                featureCode: null,
                count: 5738,
            },
            {
                featureId: '3070',
                featureName: 'Beach Nearby',
                featureCode: null,
                count: 5654,
            },
            {
                featureId: '6590',
                featureName: 'Rural',
                featureCode: 'SUPER',
                count: 5622,
            },
            {
                featureId: '2562',
                featureName: 'Open Fire or Woodburner',
                featureCode: null,
                count: 5453,
            },
            {
                featureId: '6554',
                featureName: 'Pets Free of Charge',
                featureCode: null,
                count: 5373,
            },
            {
                featureId: '6473',
                featureName: 'Grouped Property',
                featureCode: null,
                count: 5325,
            },
            {
                featureId: '6185',
                featureName: 'Barbecue',
                featureCode: null,
                count: 5115,
            },
            {
                featureId: '6788',
                featureName: 'Decorated at Christmas',
                featureCode: null,
                count: 5085,
            },
            {
                featureId: '9198',
                featureName: 'Fishing Nearby',
                featureCode: 'SUPER',
                count: 5073,
            },
            {
                featureId: '10089',
                featureName: 'Coastal Within 1 Mile',
                featureCode: null,
                count: 4462,
            },
            {
                featureId: '11198',
                featureName: 'Summer Sell Out',
                featureCode: null,
                count: 4346,
            },
            {
                featureId: '6284',
                featureName: 'Ground Floor Facilities',
                featureCode: null,
                count: 4085,
            },
            {
                featureId: '6194',
                featureName: 'Cycle Store',
                featureCode: null,
                count: 3561,
            },
            {
                featureId: '9153',
                featureName: 'Luxury',
                featureCode: 'SUPER',
                count: 3514,
            },
            {
                featureId: '10638',
                featureName: "Customers' Choice",
                featureCode: null,
                count: 3066,
            },
            {
                featureId: '9361',
                featureName: 'Newly Listed Property',
                featureCode: null,
                count: 2688,
            },
            {
                featureId: '6581',
                featureName: 'Romantic Getaways',
                featureCode: 'SUPER',
                count: 2249,
            },
            {
                featureId: '10966',
                featureName: 'Waterside Breaks',
                featureCode: null,
                count: 2097,
            },
            {
                featureId: '10295',
                featureName: 'All Ensuite',
                featureCode: null,
                count: 1887,
            },
            {
                featureId: '6464',
                featureName: 'Hot Tub',
                featureCode: 'SUPER',
                count: 1798,
            },
            {
                featureId: '13401',
                featureName: 'Autumn Savers',
                featureCode: null,
                count: 1642,
            },
            {
                featureId: '6482',
                featureName: 'Sea View',
                featureCode: 'SUPER',
                count: 1527,
            },
            {
                featureId: '11304',
                featureName: 'Train Station Within 1 Mile',
                featureCode: null,
                count: 1416,
            },
            {
                featureId: '9161',
                featureName: 'Swimming Pool',
                featureCode: 'SUPER',
                count: 1237,
            },
            {
                featureId: '9128',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 1135,
            },
            {
                featureId: '7070',
                featureName: 'Baby and Toddler Friendly',
                featureCode: 'SUPER',
                count: 952,
            },
            {
                featureId: '6419',
                featureName: 'Games Room',
                featureCode: null,
                count: 924,
            },
            {
                featureId: '10424',
                featureName: 'Childrens Play Area',
                featureCode: null,
                count: 763,
            },
            {
                featureId: '10977',
                featureName: 'Unique Cottages',
                featureCode: 'Super',
                count: 761,
            },
            {
                featureId: '9138',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 722,
            },
            {
                featureId: '10839',
                featureName: 'Electric Vehicle Charging Point',
                featureCode: null,
                count: 617,
            },
            {
                featureId: '11182',
                featureName: 'Pet - More Than Dog Friendly',
                featureCode: null,
                count: 500,
            },
            {
                featureId: '9137',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 456,
            },
            {
                featureId: '9133',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 449,
            },
            {
                featureId: '6734',
                featureName: 'Wheelchair Accessible',
                featureCode: null,
                count: 416,
            },
            {
                featureId: '3732',
                featureName: 'WiFi',
                featureCode: null,
                count: 386,
            },
            {
                featureId: '9131',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 364,
            },
            {
                featureId: '10129',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 327,
            },
            {
                featureId: '9125',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 311,
            },
            {
                featureId: '3056',
                featureName: 'Kids Play Area',
                featureCode: null,
                count: 282,
            },
            {
                featureId: '10131',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 276,
            },
            {
                featureId: '13083',
                featureName: 'Glamping Collection',
                featureCode: null,
                count: 254,
            },
            {
                featureId: '10133',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 238,
            },
            {
                featureId: '13125',
                featureName: 'zzRelax and Explore',
                featureCode: 'HOLEX',
                count: 220,
            },
            {
                featureId: '10136',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 216,
            },
            {
                featureId: '9136',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 212,
            },
            {
                featureId: '3032',
                featureName: 'Indoor Heated Pool',
                featureCode: null,
                count: 202,
            },
            {
                featureId: '9782',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 201,
            },
            {
                featureId: '3050',
                featureName: 'Family Entertainment',
                featureCode: null,
                count: 163,
            },
            {
                featureId: '3074',
                featureName: 'Fishing Nearby',
                featureCode: null,
                count: 152,
            },
            {
                featureId: '10770',
                featureName: 'Entertainment Passes Included',
                featureCode: null,
                count: 144,
            },
            {
                featureId: '9132',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 143,
            },
            {
                featureId: '3052',
                featureName: 'Kids Clubs',
                featureCode: null,
                count: 127,
            },
            {
                featureId: '9127',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 119,
            },
            {
                featureId: '13119',
                featureName: 'zzFamily Fun',
                featureCode: 'HOLEX',
                count: 105,
            },
            {
                featureId: '9126',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 104,
            },
            {
                featureId: '10128',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 100,
            },
            {
                featureId: '10134',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 100,
            },
            {
                featureId: '10137',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 97,
            },
            {
                featureId: '10275',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 92,
            },
            {
                featureId: '3223',
                featureName: 'Romantic Breaks',
                featureCode: null,
                count: 90,
            },
            {
                featureId: '9130',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 76,
            },
            {
                featureId: '10130',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 69,
            },
            {
                featureId: '12989',
                featureName: 'New in for 2022',
                featureCode: null,
                count: 63,
            },
            {
                featureId: '9277',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 60,
            },
            {
                featureId: '3222',
                featureName: 'Spa And Beauty',
                featureCode: null,
                count: 59,
            },
            {
                featureId: '9318',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 57,
            },
            {
                featureId: '10274',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 55,
            },
            {
                featureId: '10278',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 55,
            },
            {
                featureId: '10938',
                featureName: 'Golf on Site',
                featureCode: null,
                count: 52,
            },
            {
                featureId: '3506',
                featureName: 'Autograph Lodges',
                featureCode: 'SPECCOLL',
                count: 51,
            },
            {
                featureId: '10277',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 45,
            },
            {
                featureId: '9278',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 44,
            },
            {
                featureId: '10135',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 43,
            },
            {
                featureId: '10132',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 42,
            },
            {
                featureId: '5001',
                featureName: 'Evermore Lodges',
                featureCode: 'SPECCOLL',
                count: 31,
            },
            {
                featureId: '10279',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 25,
            },
            {
                featureId: '10276',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 24,
            },
            {
                featureId: '11789',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 23,
            },
            {
                featureId: '13121',
                featureName: 'zzFamily Fun Plus',
                featureCode: 'HOLEX',
                count: 23,
            },
            {
                featureId: '10929',
                featureName: 'Tailor Made',
                featureCode: 'HOLEX',
                count: 18,
            },
            {
                featureId: '10096',
                featureName: 'Popular Tourist Destinations',
                featureCode: 'AONB',
                count: 17,
            },
            {
                featureId: '2942',
                featureName: 'Promote On Availability',
                featureCode: null,
                count: 15,
            },
            {
                featureId: '9155',
                featureName: 'Daisy Door',
                featureCode: 'SPECCOLL',
                count: 11,
            },
            {
                featureId: '9741',
                featureName: 'Go Active',
                featureCode: 'SPECCOLL',
                count: 11,
            },
            {
                featureId: '10193',
                featureName: 'Wanderwood',
                featureCode: 'SPECCOLL',
                count: 10,
            },
            {
                featureId: '11964',
                featureName: 'Magnificent',
                featureCode: 'SPECCOLL',
                count: 5,
            },
            {
                featureId: '13359',
                featureName: 'Go Active Plus',
                featureCode: null,
                count: 5,
            },
            {
                featureId: '4169',
                featureName: 'Woodburner',
                featureCode: null,
                count: 5,
            },
            {
                featureId: '10902',
                featureName: "Water's Edge",
                featureCode: null,
                count: 4,
            },
            {
                featureId: '13168',
                featureName: 'zzSwimming Pool - Indoor',
                featureCode: null,
                count: 3,
            },
            {
                featureId: '3080',
                featureName: 'Access - Wheelchair',
                featureCode: null,
                count: 1,
            },
        ],
        bathrooms: [
            { bathrooms: 1, count: 10098 },
            { bathrooms: 2, count: 5811 },
            { bathrooms: 0, count: 4521 },
            { bathrooms: 3, count: 1262 },
            { bathrooms: 4, count: 422 },
            { bathrooms: 5, count: 181 },
            { bathrooms: 6, count: 69 },
            { bathrooms: 7, count: 41 },
            { bathrooms: 8, count: 21 },
            { bathrooms: 9, count: 16 },
            { bathrooms: 10, count: 5 },
            { bathrooms: 12, count: 4 },
            { bathrooms: 13, count: 4 },
            { bathrooms: 11, count: 3 },
            { bathrooms: 15, count: 1 },
            { bathrooms: 17, count: 1 },
            { bathrooms: 29, count: 1 },
        ],
        bedrooms: [
            { bedrooms: 2, count: 9516 },
            { bedrooms: 3, count: 5936 },
            { bedrooms: 1, count: 4276 },
            { bedrooms: 4, count: 1659 },
            { bedrooms: 5, count: 535 },
            { bedrooms: 6, count: 231 },
            { bedrooms: 0, count: 98 },
            { bedrooms: 7, count: 96 },
            { bedrooms: 8, count: 54 },
            { bedrooms: 9, count: 30 },
            { bedrooms: 10, count: 9 },
            { bedrooms: 11, count: 9 },
            { bedrooms: 12, count: 3 },
            { bedrooms: 13, count: 2 },
            { bedrooms: 14, count: 2 },
            { bedrooms: 16, count: 2 },
            { bedrooms: 17, count: 1 },
            { bedrooms: 18, count: 1 },
            { bedrooms: 31, count: 1 },
        ],
        regions: {
            rhs1: [{ count: 17383, regionName: 'England', regionCode: 21667 }],
            rhs2: [
                {
                    count: 5134,
                    regionName: 'South West England',
                    regionCode: 21996,
                },
                { count: 2673, regionName: 'Central England', regionCode: 21808 },
                { count: 2431, regionName: 'Yorkshire', regionCode: 21763 },
                {
                    count: 2294,
                    regionName: 'North West England',
                    regionCode: 21952,
                },
                {
                    count: 2014,
                    regionName: 'Southern England',
                    regionCode: 21668,
                },
                { count: 1605, regionName: 'East Anglia', regionCode: 21906 },
                {
                    count: 1232,
                    regionName: 'North East England',
                    regionCode: 21740,
                },
            ],
            rhs3: [
                { count: 2431, regionName: 'Yorkshire', regionCode: 21764 },
                { count: 1989, regionName: 'Cornwall', regionCode: 22070 },
                { count: 1851, regionName: 'Cumbria', regionCode: 21966 },
                { count: 1843, regionName: 'Devon', regionCode: 21997 },
                { count: 1069, regionName: 'Norfolk', regionCode: 21911 },
                { count: 1046, regionName: 'Northumberland', regionCode: 21741 },
                { count: 738, regionName: 'Dorset', regionCode: 22035 },
                { count: 638, regionName: 'Lincolnshire', regionCode: 21817 },
                { count: 606, regionName: 'Derbyshire', regionCode: 21863 },
                { count: 564, regionName: 'Somerset', regionCode: 22052 },
                { count: 533, regionName: 'Sussex', regionCode: 21699 },
                { count: 451, regionName: 'Isle of Wight', regionCode: 21730 },
                { count: 444, regionName: 'Kent', regionCode: 21669 },
                { count: 383, regionName: 'Gloucestershire', regionCode: 21843 },
                { count: 367, regionName: 'Lancashire', regionCode: 21958 },
                { count: 360, regionName: 'Suffolk', regionCode: 21933 },
                { count: 286, regionName: 'Hampshire', regionCode: 21711 },
                { count: 245, regionName: 'Shropshire', regionCode: 21880 },
                { count: 186, regionName: 'County Durham', regionCode: 21757 },
                { count: 167, regionName: 'Herefordshire', regionCode: 21898 },
                { count: 125, regionName: 'Staffordshire', regionCode: 21838 },
                { count: 121, regionName: 'Wiltshire', regionCode: 21679 },
                { count: 110, regionName: 'Essex', regionCode: 21948 },
                { count: 106, regionName: 'Worcestershire', regionCode: 21857 },
                { count: 91, regionName: 'Oxfordshire', regionCode: 21809 },
                { count: 83, regionName: 'Greater London', regionCode: 21727 },
                { count: 81, regionName: 'Nottinghamshire', regionCode: 21835 },
                { count: 76, regionName: 'Cheshire', regionCode: 21953 },
                { count: 68, regionName: 'Warwickshire', regionCode: 21827 },
                { count: 66, regionName: 'Cambridgeshire', regionCode: 21907 },
                { count: 65, regionName: 'Surrey', regionCode: 21693 },
                { count: 37, regionName: 'Leicestershire', regionCode: 21892 },
                { count: 37, regionName: 'Northamptonshire', regionCode: 21877 },
                { count: 31, regionName: 'Berkshire', regionCode: 21696 },
                { count: 26, regionName: 'Buckinghamshire', regionCode: 21889 },
                { count: 26, regionName: 'Hertfordshire', regionCode: 21814 },
                { count: 19, regionName: 'Rutland', regionCode: 21832 },
                { count: 10, regionName: 'Bedfordshire', regionCode: 21895 },
                { count: 8, regionName: 'All West Midlands', regionCode: 23673 },
            ],
            rhs4: [
                { count: 1965, regionName: 'North Yorkshire', regionCode: 21769 },
                { count: 1046, regionName: 'Northumberland', regionCode: 21742 },
                { count: 1016, regionName: 'North Norfolk', regionCode: 21912 },
                { count: 894, regionName: 'South Cornwall', regionCode: 22085 },
                { count: 851, regionName: 'South Devon', regionCode: 22017 },
                { count: 831, regionName: 'Northern Cumbria', regionCode: 23547 },
                { count: 804, regionName: 'North Cornwall', regionCode: 22071 },
                {
                    count: 767,
                    regionName: 'Central and Southern Cumbria',
                    regionCode: 23546,
                },
                { count: 738, regionName: 'Dorset', regionCode: 22036 },
                { count: 638, regionName: 'Lincolnshire', regionCode: 21818 },
                { count: 606, regionName: 'Derbyshire', regionCode: 21864 },
                { count: 599, regionName: 'North Devon', regionCode: 22004 },
                { count: 533, regionName: 'Sussex', regionCode: 21700 },
                { count: 451, regionName: 'Isle of Wight', regionCode: 21731 },
                { count: 444, regionName: 'Kent', regionCode: 21670 },
                { count: 383, regionName: 'Gloucestershire', regionCode: 21844 },
                { count: 367, regionName: 'Lancashire', regionCode: 21959 },
                { count: 360, regionName: 'Suffolk', regionCode: 21934 },
                { count: 340, regionName: 'East Yorkshire', regionCode: 21765 },
                { count: 301, regionName: 'East Somerset', regionCode: 22053 },
                { count: 291, regionName: 'West Cornwall', regionCode: 22097 },
                { count: 286, regionName: 'Hampshire', regionCode: 21712 },
                { count: 269, regionName: 'East Devon', regionCode: 21998 },
                { count: 263, regionName: 'West Somerset', regionCode: 23719 },
                { count: 253, regionName: 'Western Cumbria', regionCode: 23548 },
                { count: 245, regionName: 'Shropshire', regionCode: 21881 },
                { count: 186, regionName: 'County Durham', regionCode: 21758 },
                { count: 167, regionName: 'Herefordshire', regionCode: 21899 },
                { count: 126, regionName: 'West Yorkshire', regionCode: 21805 },
                { count: 125, regionName: 'Staffordshire', regionCode: 21839 },
                { count: 124, regionName: 'West Devon', regionCode: 22029 },
                { count: 121, regionName: 'Wiltshire', regionCode: 21680 },
                { count: 110, regionName: 'Essex', regionCode: 21949 },
                { count: 106, regionName: 'Worcestershire', regionCode: 21858 },
                { count: 91, regionName: 'Oxfordshire', regionCode: 21810 },
                { count: 83, regionName: 'Greater London', regionCode: 21728 },
                { count: 81, regionName: 'Nottinghamshire', regionCode: 21836 },
                { count: 76, regionName: 'Cheshire', regionCode: 21954 },
                { count: 68, regionName: 'Warwickshire', regionCode: 21828 },
                { count: 66, regionName: 'Cambridgeshire', regionCode: 21908 },
                { count: 65, regionName: 'Surrey', regionCode: 21694 },
                { count: 53, regionName: 'South Norfolk', regionCode: 21930 },
                { count: 37, regionName: 'Leicestershire', regionCode: 21893 },
                { count: 37, regionName: 'Northamptonshire', regionCode: 21878 },
                { count: 31, regionName: 'Berkshire', regionCode: 21697 },
                { count: 26, regionName: 'Buckinghamshire', regionCode: 21890 },
                { count: 26, regionName: 'Hertfordshire', regionCode: 21815 },
                { count: 19, regionName: 'Rutland', regionCode: 21833 },
                { count: 10, regionName: 'Bedfordshire', regionCode: 21896 },
                { count: 8, regionName: 'All West Midlands', regionCode: 23674 },
            ],
            rhs5: [
                { count: 284, regionName: 'Keswick', regionCode: 21983 },
                { count: 256, regionName: 'Whitby', regionCode: 21803 },
                { count: 185, regionName: 'Skegness', regionCode: 21826 },
                { count: 167, regionName: 'York', regionCode: 21804 },
                { count: 164, regionName: 'Torquay', regionCode: 22027 },
                { count: 158, regionName: 'Newquay', regionCode: 22077 },
                { count: 151, regionName: 'Warkworth', regionCode: 21755 },
                { count: 147, regionName: 'Bude', regionCode: 22074 },
                { count: 138, regionName: 'Bridlington', regionCode: 21766 },
                { count: 133, regionName: 'Arundel', regionCode: 21701 },
                { count: 130, regionName: 'Scarborough', regionCode: 21797 },
                { count: 128, regionName: 'Ambleside', regionCode: 21969 },
                {
                    count: 126,
                    regionName: 'Clitheroe and the Ribble Valley',
                    regionCode: 21962,
                },
                { count: 124, regionName: 'Falmouth', regionCode: 22087 },
                { count: 118, regionName: 'Bideford', regionCode: 22007 },
                { count: 115, regionName: 'St Mawes', regionCode: 23965 },
                { count: 114, regionName: 'Pickering', regionCode: 21791 },
                { count: 113, regionName: 'Happisburgh', regionCode: 21918 },
                { count: 112, regionName: 'Matlock', regionCode: 21875 },
                { count: 110, regionName: 'Paignton', regionCode: 22024 },
                {
                    count: 109,
                    regionName: 'Bowness-on-Windermere',
                    regionCode: 23549,
                },
                { count: 108, regionName: 'Poole', regionCode: 23661 },
                { count: 107, regionName: 'Filey', regionCode: 21775 },
                { count: 101, regionName: 'Lincoln', regionCode: 21822 },
                { count: 100, regionName: 'Bakewell', regionCode: 21866 },
                { count: 100, regionName: 'Dartmouth', regionCode: 22019 },
                { count: 100, regionName: 'Leyburn', regionCode: 21786 },
                { count: 99, regionName: 'Carlisle', regionCode: 21973 },
                { count: 96, regionName: 'Bournemouth', regionCode: 22040 },
                { count: 96, regionName: 'Ventnor', regionCode: 21739 },
                { count: 95, regionName: 'Alnwick', regionCode: 21743 },
                { count: 93, regionName: 'Brixham', regionCode: 22018 },
                { count: 90, regionName: 'Beadnell', regionCode: 21745 },
                { count: 90, regionName: 'Horncastle', regionCode: 21821 },
                {
                    count: 89,
                    regionName: 'Cockermouth and the North West Fells',
                    regionCode: 21974,
                },
                { count: 86, regionName: 'Cromer', regionCode: 21914 },
                { count: 84, regionName: 'Hexham', regionCode: 21749 },
                {
                    count: 84,
                    regionName: 'Windermere and Troutbeck Bridge',
                    regionCode: 21995,
                },
                { count: 83, regionName: 'Cirencester', regionCode: 21848 },
                { count: 83, regionName: 'London', regionCode: 21729 },
                { count: 83, regionName: 'Salcombe', regionCode: 23581 },
                { count: 82, regionName: 'Skipton', regionCode: 21800 },
                {
                    count: 81,
                    regionName: 'All Nottinghamshire',
                    regionCode: 21837,
                },
                { count: 81, regionName: 'Buxton', regionCode: 21869 },
                { count: 80, regionName: 'Hartland', regionCode: 22010 },
                { count: 80, regionName: 'Penrith', regionCode: 21988 },
                { count: 79, regionName: 'Bamburgh', regionCode: 21744 },
                { count: 78, regionName: 'North Walsham', regionCode: 21924 },
                { count: 76, regionName: 'Leek', regionCode: 21840 },
                { count: 76, regionName: 'Looe', regionCode: 22090 },
                {
                    count: 75,
                    regionName: 'Helston and the Lizard Peninsula',
                    regionCode: 22098,
                },
                { count: 72, regionName: 'Hawes', regionCode: 21781 },
                { count: 72, regionName: 'Weymouth', regionCode: 22050 },
                { count: 71, regionName: 'Liskeard', regionCode: 22089 },
                { count: 70, regionName: 'Hunstanton', regionCode: 21921 },
                { count: 70, regionName: 'Lowick', regionCode: 21985 },
                { count: 70, regionName: 'Morpeth', regionCode: 21750 },
                { count: 69, regionName: 'Bridport', regionCode: 22041 },
                { count: 69, regionName: 'Lydney', regionCode: 21851 },
                { count: 69, regionName: 'Seahouses', regionCode: 21754 },
                { count: 68, regionName: 'Rothbury', regionCode: 21753 },
                { count: 67, regionName: 'Flamborough', regionCode: 21768 },
                { count: 66, regionName: 'Blackpool', regionCode: 21960 },
                { count: 65, regionName: 'All Surrey', regionCode: 21695 },
                { count: 65, regionName: 'Fowey', regionCode: 22088 },
                { count: 65, regionName: 'Great Yarmouth', regionCode: 21917 },
                { count: 65, regionName: 'Holmfirth', regionCode: 21806 },
                { count: 65, regionName: 'Padstow', regionCode: 22078 },
                { count: 64, regionName: 'Kirkby Stephen', regionCode: 21984 },
                { count: 64, regionName: 'Mevagissey', regionCode: 22092 },
                { count: 64, regionName: 'Wroxham', regionCode: 21929 },
                { count: 63, regionName: 'Market Rasen', regionCode: 21825 },
                { count: 62, regionName: 'Ashford', regionCode: 21671 },
                { count: 62, regionName: 'Sheringham', regionCode: 21926 },
                { count: 62, regionName: 'Tavistock', regionCode: 22034 },
                { count: 61, regionName: 'Battle', regionCode: 21702 },
                { count: 61, regionName: 'Haworth', regionCode: 21807 },
                { count: 61, regionName: 'Mablethorpe', regionCode: 21824 },
                { count: 61, regionName: 'Plymouth', regionCode: 22025 },
                {
                    count: 61,
                    regionName: 'Silloth and the Solway Coast',
                    regionCode: 21994,
                },
                { count: 60, regionName: 'Horning', regionCode: 21920 },
                { count: 60, regionName: 'Ryde and Seaview', regionCode: 21737 },
                { count: 59, regionName: 'Appleby', regionCode: 21970 },
                { count: 59, regionName: 'Canterbury', regionCode: 21673 },
                { count: 59, regionName: 'Fakenham', regionCode: 21916 },
                { count: 59, regionName: 'Sandown', regionCode: 23653 },
                { count: 59, regionName: 'St Austell', regionCode: 22094 },
                { count: 59, regionName: 'Uckfield', regionCode: 21710 },
                { count: 58, regionName: 'Brighton', regionCode: 21704 },
                { count: 58, regionName: 'Helmsley', regionCode: 21782 },
                { count: 58, regionName: 'Kings Lynn', regionCode: 21922 },
                { count: 58, regionName: 'Lowestoft', regionCode: 21942 },
                { count: 58, regionName: 'Portscatho', regionCode: 23964 },
                { count: 58, regionName: 'Tiverton', regionCode: 22003 },
                { count: 57, regionName: 'Dorchester', regionCode: 22044 },
                {
                    count: 57,
                    regionName: 'Kendal and Lakes Gateway',
                    regionCode: 21982,
                },
                { count: 56, regionName: 'Beaworthy', regionCode: 22006 },
                { count: 56, regionName: 'Durham', regionCode: 23636 },
                { count: 56, regionName: 'Minehead', regionCode: 22061 },
                { count: 56, regionName: 'Richmond', regionCode: 21793 },
                { count: 55, regionName: 'Colchester', regionCode: 21950 },
                { count: 55, regionName: 'Shrewsbury', regionCode: 21888 },
                {
                    count: 54,
                    regionName: 'Bridgnorth and Ironbridge',
                    regionCode: 21883,
                },
                { count: 54, regionName: 'Chichester', regionCode: 21705 },
                { count: 54, regionName: 'Derby', regionCode: 21871 },
                { count: 54, regionName: 'Dereham', regionCode: 21915 },
                {
                    count: 54,
                    regionName: 'Pooley Bridge and Northern Ullswater',
                    regionCode: 21989,
                },
                {
                    count: 54,
                    regionName: 'Saltburn-by-the-Sea',
                    regionCode: 21796,
                },
                { count: 54, regionName: 'Shanklin', regionCode: 21738 },
                { count: 53, regionName: 'Bridgwater', regionCode: 22055 },
                { count: 53, regionName: 'Chipping Norton', regionCode: 21812 },
                { count: 53, regionName: 'Rye', regionCode: 21708 },
                { count: 52, regionName: 'Bassenthwaite', regionCode: 21971 },
                { count: 52, regionName: 'Broadstairs', regionCode: 21672 },
                {
                    count: 52,
                    regionName: 'Newcastle Upon Tyne',
                    regionCode: 21751,
                },
                { count: 51, regionName: 'Maidstone', regionCode: 23590 },
                { count: 50, regionName: 'Brundall', regionCode: 21913 },
                { count: 50, regionName: 'Exeter', regionCode: 22000 },
                { count: 50, regionName: 'St Ives', regionCode: 22103 },
                { count: 50, regionName: 'Staithes', regionCode: 21801 },
                {
                    count: 50,
                    regionName: 'Truro and the Roseland Peninsula',
                    regionCode: 22096,
                },
                { count: 49, regionName: 'Beverley', regionCode: 23897 },
                { count: 49, regionName: 'Brassington', regionCode: 21868 },
                { count: 49, regionName: 'Grassington', regionCode: 21778 },
                { count: 49, regionName: 'Newton Abbot', regionCode: 22022 },
                { count: 48, regionName: 'Driffield', regionCode: 21767 },
                { count: 48, regionName: 'Louth', regionCode: 21823 },
                {
                    count: 47,
                    regionName: 'Berwick-upon-Tweed',
                    regionCode: 21746,
                },
                { count: 47, regionName: 'Chesterfield', regionCode: 21870 },
                { count: 47, regionName: 'Cowes', regionCode: 21734 },
                { count: 47, regionName: 'Winterton-on-Sea', regionCode: 21928 },
                { count: 46, regionName: 'Harrogate', regionCode: 21779 },
                { count: 46, regionName: 'Launceston', regionCode: 22076 },
                { count: 46, regionName: 'Porthtowan', regionCode: 23652 },
                {
                    count: 46,
                    regionName: 'Taunton and The Quantocks',
                    regionCode: 22065,
                },
                {
                    count: 46,
                    regionName: 'Ulverston and Lakeland Peninsula',
                    regionCode: 21993,
                },
                { count: 45, regionName: 'Boston', regionCode: 21819 },
                {
                    count: 45,
                    regionName: 'Callington and the Tamar Valley',
                    regionCode: 22086,
                },
                { count: 45, regionName: 'Dawlish', regionCode: 22020 },
                { count: 45, regionName: 'Grantham', regionCode: 21820 },
                { count: 45, regionName: 'Halesworth', regionCode: 21939 },
                { count: 45, regionName: 'Oswestry', regionCode: 21887 },
                { count: 45, regionName: 'Settle', regionCode: 21799 },
                { count: 44, regionName: 'Barnard Castle', regionCode: 21759 },
                { count: 44, regionName: 'Gloucester', regionCode: 21850 },
                { count: 44, regionName: 'Ringwood', regionCode: 21723 },
                { count: 44, regionName: 'Stroud', regionCode: 21854 },
                { count: 43, regionName: 'Camelford', regionCode: 22075 },
                { count: 43, regionName: 'Craster', regionCode: 21747 },
                { count: 43, regionName: 'Ely', regionCode: 21910 },
                { count: 43, regionName: 'Ilfracombe', regionCode: 22012 },
                { count: 43, regionName: 'Port Isaac', regionCode: 22080 },
                { count: 43, regionName: 'Wooler', regionCode: 21756 },
                { count: 42, regionName: 'Ashbourne', regionCode: 21865 },
                { count: 42, regionName: 'Wimborne', regionCode: 22051 },
                {
                    count: 41,
                    regionName: 'Threlkeld and St Johns in the Vale',
                    regionCode: 23563,
                },
                { count: 40, regionName: 'Bath', regionCode: 22054 },
                { count: 40, regionName: 'Cheddar', regionCode: 23594 },
                { count: 40, regionName: 'Haltwhistle', regionCode: 21748 },
                { count: 40, regionName: 'Newport', regionCode: 21736 },
                { count: 40, regionName: 'Sidmouth', regionCode: 23626 },
                { count: 40, regionName: 'Whitstable', regionCode: 21678 },
                { count: 39, regionName: 'Caldbeck Fells', regionCode: 23553 },
                { count: 39, regionName: 'Chester', regionCode: 21955 },
                { count: 39, regionName: 'Combe Martin', regionCode: 22009 },
                {
                    count: 39,
                    regionName: 'Greater Manchester',
                    regionCode: 23968,
                },
                { count: 39, regionName: 'Harwood Dale', regionCode: 21780 },
                { count: 39, regionName: 'Westward Ho!', regionCode: 23831 },
                { count: 38, regionName: 'Bedale', regionCode: 21770 },
                { count: 38, regionName: 'Eye', regionCode: 21938 },
                { count: 38, regionName: 'Perranporth', regionCode: 22079 },
                { count: 38, regionName: 'Portsmouth', regionCode: 21722 },
                { count: 38, regionName: 'Southport', regionCode: 21965 },
                {
                    count: 37,
                    regionName: 'All Leicestershire',
                    regionCode: 21894,
                },
                {
                    count: 37,
                    regionName: 'All Northamptonshire',
                    regionCode: 21879,
                },
                { count: 37, regionName: 'Folkestone', regionCode: 21676 },
                { count: 37, regionName: 'Grange-over-Sands', regionCode: 21979 },
                { count: 37, regionName: 'Hereford', regionCode: 21901 },
                { count: 37, regionName: 'Maldon', regionCode: 21951 },
                { count: 37, regionName: 'Norwich', regionCode: 21925 },
                { count: 37, regionName: 'Otterburn', regionCode: 21752 },
                { count: 37, regionName: 'Salisbury', regionCode: 21689 },
                { count: 36, regionName: 'Beaminster', regionCode: 22037 },
                { count: 36, regionName: 'Bodmin', regionCode: 22072 },
                { count: 36, regionName: 'Chard', regionCode: 22057 },
                { count: 36, regionName: 'Claxton', regionCode: 21773 },
                { count: 36, regionName: 'Kettlewell', regionCode: 21784 },
                { count: 36, regionName: 'Lyme Regis', regionCode: 22045 },
                { count: 36, regionName: 'Ross-On-Wye', regionCode: 21905 },
                { count: 36, regionName: 'Selby', regionCode: 21798 },
                { count: 36, regionName: 'St Columb Major', regionCode: 22083 },
                { count: 36, regionName: 'Stafford', regionCode: 21841 },
                { count: 36, regionName: 'Thirsk', regionCode: 21802 },
                { count: 36, regionName: 'Torrington', regionCode: 22014 },
                { count: 36, regionName: 'Weston Super Mare', regionCode: 22068 },
                { count: 35, regionName: 'Bishop Auckland', regionCode: 21760 },
                { count: 35, regionName: 'Holsworthy', regionCode: 22011 },
                { count: 35, regionName: 'Lancaster', regionCode: 21963 },
                { count: 35, regionName: 'Melton Constable', regionCode: 21923 },
                { count: 35, regionName: 'St Bees', regionCode: 23589 },
                { count: 35, regionName: 'Tunbridge Wells', regionCode: 21677 },
                {
                    count: 35,
                    regionName: 'Wells-next-the-Sea',
                    regionCode: 21927,
                },
                { count: 34, regionName: 'Barnstaple', regionCode: 22005 },
                { count: 34, regionName: 'Bognor Regis', regionCode: 21703 },
                { count: 34, regionName: 'Burnham-on-Sea', regionCode: 22056 },
                { count: 34, regionName: 'Freshwater', regionCode: 21735 },
                { count: 34, regionName: 'Hastings', regionCode: 21707 },
                { count: 34, regionName: 'Leominster', regionCode: 21904 },
                { count: 34, regionName: 'Lytham St Annes', regionCode: 23635 },
                { count: 34, regionName: 'Marazion', regionCode: 22099 },
                {
                    count: 34,
                    regionName: 'Stratford-Upon-Avon',
                    regionCode: 21830,
                },
                { count: 34, regionName: 'Wadebridge', regionCode: 23595 },
                { count: 34, regionName: 'Yeovil', regionCode: 22069 },
                { count: 33, regionName: 'Eastbourne', regionCode: 21706 },
                { count: 33, regionName: 'Glastonbury', regionCode: 22060 },
                { count: 33, regionName: 'Malvern', regionCode: 21860 },
                { count: 33, regionName: 'Pateley Bridge', regionCode: 23669 },
                { count: 32, regionName: 'Cayton', regionCode: 21772 },
                { count: 32, regionName: 'Danby', regionCode: 21774 },
                { count: 32, regionName: 'Ledbury', regionCode: 21903 },
                { count: 32, regionName: 'Malton', regionCode: 21788 },
                { count: 32, regionName: 'Portreath', regionCode: 22081 },
                { count: 32, regionName: 'St Just', regionCode: 22104 },
                { count: 32, regionName: 'Stanhope', regionCode: 21762 },
                { count: 32, regionName: 'Tideswell', regionCode: 21876 },
                {
                    count: 32,
                    regionName: 'Woolacombe and Croyde',
                    regionCode: 22015,
                },
                { count: 31, regionName: 'All Berkshire', regionCode: 21698 },
                { count: 31, regionName: 'Diss', regionCode: 21931 },
                {
                    count: 31,
                    regionName: 'Grasmere and the Langdale Valley',
                    regionCode: 23550,
                },
                { count: 31, regionName: 'Honiton', regionCode: 22001 },
                { count: 31, regionName: 'Hope Valley', regionCode: 21874 },
                { count: 31, regionName: 'Hornsea', regionCode: 23924 },
                { count: 31, regionName: 'Polperro', regionCode: 23596 },
                { count: 31, regionName: 'Teignmouth', regionCode: 22026 },
                { count: 30, regionName: 'Cheltenham', regionCode: 21846 },
                { count: 30, regionName: 'Chulmleigh', regionCode: 22008 },
                { count: 30, regionName: 'Kirkbymoorside', regionCode: 21785 },
                { count: 30, regionName: 'Worcester', regionCode: 21862 },
                {
                    count: 29,
                    regionName: 'Coniston and Grizedale',
                    regionCode: 21975,
                },
                { count: 29, regionName: 'Oxford', regionCode: 21813 },
                { count: 29, regionName: 'Tintagel', regionCode: 22084 },
                { count: 28, regionName: 'Bury St Edmunds', regionCode: 21937 },
                { count: 28, regionName: 'Kirkby Lonsdale', regionCode: 23545 },
                { count: 28, regionName: 'Penzance', regionCode: 22101 },
                { count: 28, regionName: 'Reeth', regionCode: 21792 },
                { count: 28, regionName: 'Sherborne', regionCode: 22047 },
                { count: 28, regionName: 'Somerton', regionCode: 23875 },
                { count: 27, regionName: 'Axminster', regionCode: 21999 },
                { count: 27, regionName: 'Christchurch', regionCode: 23852 },
                { count: 27, regionName: 'Crackington Haven', regionCode: 23630 },
                { count: 27, regionName: 'Kingsbridge', regionCode: 22021 },
                { count: 27, regionName: 'Totnes', regionCode: 22028 },
                {
                    count: 26,
                    regionName: 'All Buckinghamshire',
                    regionCode: 21891,
                },
                { count: 26, regionName: 'All Hertfordshire', regionCode: 21816 },
                { count: 26, regionName: 'Alton', regionCode: 21713 },
                { count: 26, regionName: 'Bristol', regionCode: 23969 },
                { count: 26, regionName: 'Deal', regionCode: 21674 },
                { count: 26, regionName: 'Glaisdale', regionCode: 21776 },
                {
                    count: 26,
                    regionName: 'Staveley and the Kentmere Valley',
                    regionCode: 23629,
                },
                { count: 26, regionName: 'Yarmouth', regionCode: 23633 },
                { count: 25, regionName: 'Alston', regionCode: 21968 },
                { count: 25, regionName: 'Bovey Tracey', regionCode: 23764 },
                { count: 25, regionName: 'Exmouth', regionCode: 23522 },
                { count: 25, regionName: 'Lymington', regionCode: 21720 },
                { count: 25, regionName: 'Margate', regionCode: 23893 },
                { count: 25, regionName: 'Mawgan Porth', regionCode: 23838 },
                { count: 25, regionName: 'Nantwich', regionCode: 21957 },
                { count: 25, regionName: 'Saxmundham', regionCode: 21943 },
                { count: 25, regionName: 'Winchester', regionCode: 21726 },
                { count: 25, regionName: 'Woodbridge', regionCode: 21947 },
                { count: 24, regionName: 'Aldeburgh', regionCode: 21935 },
                { count: 24, regionName: 'Church Stretton', regionCode: 21884 },
                { count: 24, regionName: 'Dungeness', regionCode: 23891 },
                {
                    count: 24,
                    regionName: 'Haverigg and the National Park Coast',
                    regionCode: 21987,
                },
                { count: 24, regionName: 'Holt', regionCode: 21919 },
                { count: 24, regionName: 'Ingleton', regionCode: 21783 },
                { count: 24, regionName: 'Ipswich', regionCode: 21940 },
                { count: 24, regionName: 'Ludlow', regionCode: 21886 },
                { count: 24, regionName: 'Matterdale End', regionCode: 21986 },
                { count: 24, regionName: 'Wells', regionCode: 22067 },
                { count: 23, regionName: 'Belper', regionCode: 21867 },
                { count: 23, regionName: 'Chipping Campden', regionCode: 21847 },
                { count: 23, regionName: 'Glossop', regionCode: 21873 },
                { count: 23, regionName: 'Hayle', regionCode: 23534 },
                { count: 23, regionName: 'Kielder', regionCode: 23568 },
                { count: 23, regionName: 'Lynton', regionCode: 22013 },
                { count: 23, regionName: 'Okehampton', regionCode: 22032 },
                {
                    count: 23,
                    regionName: 'Royal Wootton Bassett',
                    regionCode: 21688,
                },
                { count: 23, regionName: 'Shaftesbury', regionCode: 22046 },
                { count: 23, regionName: 'Wareham', regionCode: 22049 },
                {
                    count: 22,
                    regionName: 'Bourton-on-the-Water',
                    regionCode: 21845,
                },
                { count: 22, regionName: 'Craven Arms', regionCode: 21885 },
                { count: 22, regionName: 'Goathland', regionCode: 21777 },
                { count: 22, regionName: 'Thetford', regionCode: 21932 },
                { count: 21, regionName: 'Beccles', regionCode: 21936 },
                { count: 21, regionName: 'Bishops Castle', regionCode: 21882 },
                { count: 21, regionName: 'Blandford Forum', regionCode: 22039 },
                { count: 21, regionName: 'Downderry', regionCode: 23881 },
                { count: 21, regionName: 'Frome', regionCode: 22059 },
                { count: 21, regionName: 'Portland', regionCode: 23830 },
                { count: 20, regionName: 'Bembridge', regionCode: 21732 },
                {
                    count: 20,
                    regionName: 'Buttermere and Borrowdale',
                    regionCode: 23552,
                },
                { count: 20, regionName: 'Chideock', regionCode: 22043 },
                { count: 20, regionName: 'Warwick', regionCode: 21831 },
                { count: 19, regionName: 'All Rutland', regionCode: 21834 },
                { count: 19, regionName: 'Alnmouth', regionCode: 23564 },
                { count: 19, regionName: 'Blakeney', regionCode: 23631 },
                { count: 19, regionName: 'Cartmel', regionCode: 23628 },
                { count: 19, regionName: 'Coleford', regionCode: 21849 },
                { count: 19, regionName: 'Hayling Island', regionCode: 23861 },
                { count: 19, regionName: 'Lostwithiel', regionCode: 22091 },
                { count: 19, regionName: 'Robin Hoods Bay', regionCode: 23623 },
                { count: 19, regionName: 'Sudbury', regionCode: 21946 },
                { count: 19, regionName: 'Swanage', regionCode: 22048 },
                { count: 18, regionName: 'Boscastle', regionCode: 22073 },
                { count: 18, regionName: 'Chipping Sodbury', regionCode: 23625 },
                { count: 18, regionName: 'Dulverton', regionCode: 22058 },
                { count: 18, regionName: 'Evesham', regionCode: 21859 },
                { count: 18, regionName: 'Faversham', regionCode: 23892 },
                { count: 18, regionName: 'Harbottle', regionCode: 23567 },
                {
                    count: 18,
                    regionName: 'Hawkshead and Near and Far Sawrey',
                    regionCode: 21980,
                },
                { count: 18, regionName: 'Stowmarket', regionCode: 21945 },
                { count: 18, regionName: 'Watchet', regionCode: 22066 },
                { count: 17, regionName: 'Andover', regionCode: 21714 },
                {
                    count: 17,
                    regionName: 'Charlestown and Duporth',
                    regionCode: 23832,
                },
                { count: 17, regionName: 'Eskdale', regionCode: 21977 },
                {
                    count: 17,
                    regionName: 'Mousehole and Newlyn',
                    regionCode: 22100,
                },
                { count: 17, regionName: 'Southwold', regionCode: 21944 },
                { count: 17, regionName: 'Tenbury Wells', regionCode: 21861 },
                { count: 17, regionName: 'Umberleigh', regionCode: 23851 },
                { count: 16, regionName: 'Buckfastleigh', regionCode: 22030 },
                { count: 16, regionName: 'Cambridge', regionCode: 21909 },
                { count: 16, regionName: 'Consett', regionCode: 21761 },
                { count: 16, regionName: 'Kessingland', regionCode: 21941 },
                { count: 16, regionName: 'Kington', regionCode: 21902 },
                { count: 16, regionName: 'Shepton Mallet', regionCode: 22064 },
                { count: 16, regionName: 'Southampton', regionCode: 21724 },
                { count: 15, regionName: 'Brighstone', regionCode: 21733 },
                { count: 15, regionName: 'Carnforth', regionCode: 21961 },
                { count: 15, regionName: 'Dover', regionCode: 21675 },
                { count: 15, regionName: 'Rosedale Abbey', regionCode: 21795 },
                { count: 15, regionName: 'Shaldon', regionCode: 23651 },
                {
                    count: 15,
                    regionName: 'Sturminster Newton',
                    regionCode: 23855,
                },
                { count: 14, regionName: 'Alcester', regionCode: 21829 },
                {
                    count: 14,
                    regionName: 'Arnside and Silverdale',
                    regionCode: 21964,
                },
                {
                    count: 14,
                    regionName: 'Broughton-in-furness',
                    regionCode: 21972,
                },
                { count: 14, regionName: 'Cullompton', regionCode: 23856 },
                {
                    count: 14,
                    regionName: 'Gosforth and Wasdale',
                    regionCode: 23624,
                },
                { count: 14, regionName: 'Ivybridge', regionCode: 22031 },
                { count: 14, regionName: 'Muker', regionCode: 21789 },
                {
                    count: 14,
                    regionName: 'Saunton and Braunton',
                    regionCode: 23828,
                },
                { count: 14, regionName: 'Seaton', regionCode: 22002 },
                { count: 14, regionName: 'Selsey', regionCode: 21709 },
                { count: 14, regionName: 'St Breock', regionCode: 23829 },
                { count: 14, regionName: 'Thornthwaite', regionCode: 23562 },
                { count: 13, regionName: 'Bellingham', regionCode: 23565 },
                { count: 13, regionName: 'Bettiscombe', regionCode: 22038 },
                { count: 13, regionName: 'Brockenhurst', regionCode: 21715 },
                { count: 13, regionName: 'Fareham', regionCode: 21719 },
                {
                    count: 13,
                    regionName: 'Glenridding and Southern Ullswater',
                    regionCode: 21978,
                },
                { count: 13, regionName: 'Praa Sands', regionCode: 23865 },
                { count: 13, regionName: 'Ripon', regionCode: 21794 },
                { count: 13, regionName: 'Stoke-on-Trent', regionCode: 21842 },
                { count: 13, regionName: 'Tewkesbury', regionCode: 21855 },
                {
                    count: 13,
                    regionName: 'Ulpha and the Duddon Valley',
                    regionCode: 21992,
                },
                { count: 12, regionName: 'Braithwaite', regionCode: 23551 },
                { count: 12, regionName: 'Brompton', regionCode: 21771 },
                { count: 12, regionName: 'Brook', regionCode: 21716 },
                { count: 12, regionName: 'Edale', regionCode: 21872 },
                { count: 12, regionName: 'Hay-on-Wye', regionCode: 21900 },
                { count: 12, regionName: 'Macclesfield', regionCode: 21956 },
                { count: 12, regionName: 'Malham', regionCode: 21787 },
                { count: 11, regionName: 'Burley', regionCode: 21717 },
                { count: 11, regionName: 'East Meon', regionCode: 21718 },
                { count: 11, regionName: 'Moreton-In-Marsh', regionCode: 21852 },
                { count: 11, regionName: 'Sennen', regionCode: 22102 },
                { count: 10, regionName: 'All Bedfordshire', regionCode: 21897 },
                {
                    count: 10,
                    regionName: 'Beer and Branscombe',
                    regionCode: 23622,
                },
                { count: 10, regionName: 'Chippenham', regionCode: 21683 },
                { count: 10, regionName: 'Devizes', regionCode: 21684 },
                { count: 10, regionName: 'Great Strickland', regionCode: 23555 },
                { count: 10, regionName: 'Mersea Island', regionCode: 23913 },
                { count: 10, regionName: 'Northallerton', regionCode: 21790 },
                { count: 10, regionName: 'St Agnes', regionCode: 23593 },
                { count: 10, regionName: 'West Meon', regionCode: 21725 },
                { count: 9, regionName: 'Banbury', regionCode: 21811 },
                { count: 9, regionName: 'Saltash', regionCode: 22093 },
                { count: 9, regionName: 'West Lulworth', regionCode: 23841 },
                { count: 8, regionName: 'All West Midlands', regionCode: 23675 },
                { count: 8, regionName: 'Broadway', regionCode: 23582 },
                { count: 8, regionName: 'Kingswear', regionCode: 23853 },
                { count: 8, regionName: 'Porthcurno', regionCode: 23864 },
                {
                    count: 8,
                    regionName: 'Torpoint and Wilcove',
                    regionCode: 23837,
                },
                { count: 8, regionName: 'Trowbridge', regionCode: 21690 },
                { count: 7, regionName: 'South Brent', regionCode: 22033 },
                { count: 7, regionName: 'Stow-on-the-Wold', regionCode: 21853 },
                { count: 7, regionName: 'Withernsea', regionCode: 23923 },
                { count: 6, regionName: 'Clacton-on-Sea', regionCode: 23911 },
                { count: 6, regionName: 'Marlborough', regionCode: 21686 },
                { count: 6, regionName: 'Mere', regionCode: 21687 },
                { count: 6, regionName: 'Petersfield', regionCode: 21721 },
                { count: 6, regionName: 'Warminster', regionCode: 21691 },
                { count: 6, regionName: 'Watergate Bay', regionCode: 23880 },
                { count: 6, regionName: 'Westbury', regionCode: 21692 },
                { count: 5, regionName: 'Malmesbury', regionCode: 21685 },
                { count: 5, regionName: 'Polzeath', regionCode: 23863 },
                { count: 5, regionName: 'Porlock', regionCode: 22062 },
                {
                    count: 5,
                    regionName: 'Sedbergh and the Howgill Fells',
                    regionCode: 21991,
                },
                { count: 5, regionName: 'Wisbech', regionCode: 23763 },
                { count: 4, regionName: 'Arnside', regionCode: 23962 },
                {
                    count: 4,
                    regionName: 'Hallsands and Beesands',
                    regionCode: 23869,
                },
                {
                    count: 4,
                    regionName: 'Newbiggin-by-the-Sea',
                    regionCode: 23916,
                },
                { count: 4, regionName: 'Newton and Noss', regionCode: 22023 },
                { count: 4, regionName: 'Stokesley', regionCode: 23922 },
                {
                    count: 3,
                    regionName: 'Bigbury On Sea and Challaborough',
                    regionCode: 23868,
                },
                { count: 3, regionName: 'Bradford Abbas', regionCode: 23845 },
                { count: 3, regionName: 'Crediton', regionCode: 23857 },
                { count: 3, regionName: 'Dent', regionCode: 21976 },
                {
                    count: 3,
                    regionName: 'Durham Heritage Coast',
                    regionCode: 23915,
                },
                {
                    count: 3,
                    regionName: 'Kingsand and Cawsand',
                    regionCode: 22095,
                },
                { count: 2, regionName: 'Bradford-on-Avon', regionCode: 21681 },
                { count: 2, regionName: 'Castle Combe', regionCode: 21682 },
                { count: 2, regionName: 'Felixstowe', regionCode: 23914 },
                { count: 2, regionName: 'Harwich', regionCode: 23912 },
                { count: 2, regionName: 'Lifton', regionCode: 23847 },
                { count: 2, regionName: 'Peterborough', regionCode: 23910 },
                { count: 2, regionName: 'Portwrinkle', regionCode: 23862 },
                { count: 2, regionName: 'Rock', regionCode: 23843 },
                {
                    count: 2,
                    regionName: 'Slapton and Torcross',
                    regionCode: 23866,
                },
                { count: 1, regionName: 'East Woodburn', regionCode: 23566 },
                { count: 1, regionName: 'Whitsand Bay', regionCode: 23833 },
            ],
        },
        accommodationTypes: [{ accommodationId: '1', count: 100 }],
        grades: [],
    },
};
exports.GET_SITES_SERVICES_API_RESPONSE_200 = {
    total: 1,
    rhsLevel: 'rhs1',
    sites: [
        {
            code: 'WINL',
            displayName: 'Winston Farm Lodges',
            grade: '3',
            offers: [
                '<em>Up to an EXTRA &pound;70* off summer breaks</em>Limited time only &ndash; terms & conditions apply https://www.hoseasons.co.uk/terms-and-conditions',
            ],
            location: 'Tetchill',
            fromPrice: 0,
            price: null,
            wasPrice: null,
            services: [
                {
                    code: 'LP18304',
                    name: 'Heron',
                    accommodationType: 'Lodge',
                    fromPrice: 649.0,
                    bathroomCount: 0,
                    bedroomCount: 2,
                    sleeps: 4,
                    pets: 0,
                    price: undefined,
                    wasPrice: undefined,
                    startDate: '2023-05-01',
                },
                {
                    code: 'LP18305',
                    name: 'Kingfisher',
                    fromPrice: 675.0,
                    bathroomCount: 0,
                    bedroomCount: 2,
                    sleeps: 4,
                    pets: 0,
                    price: undefined,
                    wasPrice: undefined,
                    startDate: '2023-05-01',
                },
                {
                    code: 'LP18306',
                    name: 'Lapwing',
                    accommodationType: 'Park',
                    fromPrice: 675.0,
                    bathroomCount: 0,
                    bedroomCount: 2,
                    sleeps: 4,
                    pets: 1,
                    price: undefined,
                    wasPrice: undefined,
                    startDate: '2023-05-01',
                },
            ],
            rhs3: 'rhs3',
            novasolProperty: null,
        },
    ],
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '8821',
                featureName: 'Cot Available',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6428',
                featureName: 'Highchair Available',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6275',
                featureName: 'Dishwasher',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '3084',
                featureName: 'Hot Tub - Private',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9857',
                featureName: 'Pet(s) Allowed',
                featureCode: null,
                count: 1,
            },
        ],
        siteFeatures: [
            {
                featureId: '3506',
                featureName: 'Autograph Lodges',
                featureCode: 'SPECCOLL',
                count: 1,
            },
            {
                featureId: '3732',
                featureName: 'WiFi',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9153',
                featureName: 'Luxury',
                featureCode: 'SUPER',
                count: 1,
            },
        ],
        bathrooms: [
            {
                bathrooms: 0,
                count: 3,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 3,
            },
        ],
        regions: {
            rhs1: [
                {
                    count: 1,
                    regionName: 'England',
                    regionCode: 21667,
                },
            ],
            rhs2: [
                {
                    count: 1,
                    regionName: 'Central England',
                    regionCode: 21808,
                },
            ],
            rhs3: [
                {
                    count: 1,
                    regionName: 'Shropshire',
                    regionCode: 21880,
                },
            ],
            rhs4: [
                {
                    count: 1,
                    regionName: 'Shropshire',
                    regionCode: 21881,
                },
            ],
            rhs5: [
                {
                    count: 1,
                    regionName: 'Oswestry',
                    regionCode: 21887,
                },
            ],
        },
        grades: [],
    },
};
exports.GET_NOVASOL_API_RESPONSE_200 = {
    total: 37830,
    sites: [
        {
            code: 'EAL136',
            displayName: 'Chiclana de la Frontera',
            grade: '4',
            offers: [],
            location: 'Spain',
            fromPrice: 950.0,
            price: null,
            wasPrice: null,
            startDate: '2023-04-29', // novasol will send through next availible date in undated searches
            lengthOfStay: 7,
            novasolProperty: {
                adults: 6,
                children: 0,
                pets: 1,
                bathrooms: 2,
                bedrooms: 3,
                includedExtras: [202, 201, 0],
            },
            services: [],
            rhs3: 'rhs3',
        },
    ],
    aggregations: {
        accommodationTypes: [
            {
                accommodationId: 'ACCOM-2',
                count: 89,
            },
            {
                accommodationId: 'ACCOM-3',
                count: 26973,
            },
            {
                accommodationId: 'ACCOM-1',
                count: 10754,
            },
        ],
        features: [
            {
                featureId: 'FILT-11',
                featureName: null,
                featureCode: null,
                count: 35553,
            },
            {
                featureId: 'FILT-7',
                featureName: null,
                featureCode: null,
                count: 6573,
            },
            {
                featureId: 'FILT-34',
                featureName: null,
                featureCode: null,
                count: 2207,
            },
            {
                featureId: 'FILT-13',
                featureName: null,
                featureCode: null,
                count: 6292,
            },
            {
                featureId: 'FILT-22',
                featureName: null,
                featureCode: null,
                count: 3500,
            },
            {
                featureId: 'FILT-17',
                featureName: null,
                featureCode: null,
                count: 1381,
            },
            {
                featureId: 'FILT-3',
                featureName: null,
                featureCode: null,
                count: 26686,
            },
            {
                featureId: 'FILT-28',
                featureName: null,
                featureCode: null,
                count: 60,
            },
            {
                featureId: 'FILT-18',
                featureName: null,
                featureCode: null,
                count: 4655,
            },
            {
                featureId: 'FILT-24',
                featureName: null,
                featureCode: null,
                count: 15100,
            },
            {
                featureId: 'FILT-6',
                featureName: null,
                featureCode: null,
                count: 24866,
            },
            {
                featureId: 'FILT-1',
                featureName: null,
                featureCode: null,
                count: 15791,
            },
            {
                featureId: 'FILT-14',
                featureName: null,
                featureCode: null,
                count: 2384,
            },
            {
                featureId: 'FILT-4',
                featureName: null,
                featureCode: null,
                count: 15022,
            },
            {
                featureId: 'FILT-2',
                featureName: null,
                featureCode: null,
                count: 480,
            },
            {
                featureId: 'FILT-9',
                featureName: null,
                featureCode: null,
                count: 1393,
            },
            {
                featureId: 'FILT-30',
                featureName: null,
                featureCode: null,
                count: 18709,
            },
            {
                featureId: 'FILT-5',
                featureName: null,
                featureCode: null,
                count: 32787,
            },
            {
                featureId: 'FILT-19',
                featureName: null,
                featureCode: null,
                count: 1191,
            },
            {
                featureId: 'FILT-29',
                featureName: null,
                featureCode: null,
                count: 1822,
            },
            {
                featureId: 'FILT-10',
                featureName: null,
                featureCode: null,
                count: 10569,
            },
            {
                featureId: 'FILT-16',
                featureName: null,
                featureCode: null,
                count: 1257,
            },
            {
                featureId: 'FILT-8',
                featureName: null,
                featureCode: null,
                count: 282,
            },
            {
                featureId: 'FILT-21',
                featureName: null,
                featureCode: null,
                count: 5924,
            },
            {
                featureId: 'FILT-27',
                featureName: null,
                featureCode: null,
                count: 2335,
            },
            {
                featureId: 'FILT-35',
                featureName: null,
                featureCode: null,
                count: 1047,
            },
            {
                featureId: 'FILT-12',
                featureName: null,
                featureCode: null,
                count: 28672,
            },
            {
                featureId: 'FILT-25',
                featureName: null,
                featureCode: null,
                count: 2644,
            },
            {
                featureId: 'FILT-15',
                featureName: null,
                featureCode: null,
                count: 11494,
            },
            {
                featureId: 'FILT-31',
                featureName: null,
                featureCode: null,
                count: 16031,
            },
            {
                featureId: 'FILT-33',
                featureName: null,
                featureCode: null,
                count: 22517,
            },
            {
                featureId: 'FILT-32',
                featureName: null,
                featureCode: null,
                count: 21806,
            },
            {
                featureId: 'FILT-20',
                featureName: null,
                featureCode: null,
                count: 3507,
            },
            {
                featureId: 'FILT-26',
                featureName: null,
                featureCode: null,
                count: 13478,
            },
            {
                featureId: 'FILT-23',
                featureName: null,
                featureCode: null,
                count: 26540,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 0,
                count: 110,
            },
            {
                bathrooms: 10,
                count: 50,
            },
            {
                bathrooms: 1,
                count: 22764,
            },
            {
                bathrooms: 2,
                count: 10433,
            },
            {
                bathrooms: 3,
                count: 2471,
            },
            {
                bathrooms: 4,
                count: 1136,
            },
            {
                bathrooms: 5,
                count: 490,
            },
            {
                bathrooms: 6,
                count: 232,
            },
            {
                bathrooms: 7,
                count: 109,
            },
            {
                bathrooms: 8,
                count: 55,
            },
            {
                bathrooms: 9,
                count: 24,
            },
        ],
        bedrooms: [
            {
                bedrooms: 0,
                count: 503,
            },
            {
                bedrooms: 10,
                count: 124,
            },
            {
                bedrooms: 1,
                count: 4400,
            },
            {
                bedrooms: 2,
                count: 13041,
            },
            {
                bedrooms: 3,
                count: 11382,
            },
            {
                bedrooms: 4,
                count: 5313,
            },
            {
                bedrooms: 5,
                count: 1735,
            },
            {
                bedrooms: 6,
                count: 778,
            },
            {
                bedrooms: 7,
                count: 310,
            },
            {
                bedrooms: 8,
                count: 187,
            },
            {
                bedrooms: 9,
                count: 108,
            },
        ],
        regions: {
            rhs1: [],
            rhs2: [],
            rhs3: [],
            rhs4: [],
            rhs5: [],
        },
        grades: [],
    },
    rhsLevel: 'rhs1',
};
exports.GET_NOVASOL_API_RESPONSE_200_DATED_SEARCH = {
    ...exports.GET_NOVASOL_API_RESPONSE_200,
    sites: [
        {
            ...exports.GET_NOVASOL_API_RESPONSE_200.sites[0],
            startDate: '2023-04-29',
            lengthOfStay: 7,
            price: 10000,
            fromPrice: null,
            wasPrice: null,
        },
    ],
};
exports.GET_SITES_API_RESPONSE_404 = {
    type: 'NOT_FOUND_ERROR',
    errors: [
        {
            message: 'Incorrect Path, Parameter Name or Parameter Type',
        },
    ],
};
exports.GET_SITES_API_RESPONSE_400 = {
    type: 'VALIDATION_ERROR',
    errors: [
        {
            message: 'groups contains an invalid group. Valid groups are: PARKS, LODGES, COTTAGES',
        },
    ],
};
exports.GET_SITES_SERVICES_API_RESPONSE_400 = {
    type: 'VALIDATION_ERROR',
    errors: [
        {
            message: 'groups contains an invalid group. Valid groups are: PARKS, LODGES, COTTAGES',
        },
    ],
};
exports.GET_SITES_API_NO_RESULTS_RESPONSE = {
    total: 0,
    sites: [],
    aggregations: {
        accommodationTypes: [],
        features: [],
        siteFeatures: [],
        bathrooms: [],
        bedrooms: [],
        regions: {
            rhs1: [],
            rhs2: [],
            rhs3: [],
            rhs4: [],
            rhs5: [],
        },
        grades: [],
    },
    rhsLevel: 'rhs1',
};
//# sourceMappingURL=sites.js.map